import { Plugin } from './Plugin';
import { APP_URL } from 'js/common/AppUrl';
import { TextureLoader } from '../loaders';
import { CanvasTexture, EquirectangularReflectionMapping, sRGBEncoding } from 'three';
import { GlobalsPlugin } from './GlobalsPlugin';
import { ScenePlugin } from './ScenePlugin';

const PI2 = Math.PI * 2;

export class BackgroundPlugin extends Plugin{
	constructor(manager){
		super(manager);
		this.dependencies.add(GlobalsPlugin);
		this.dependencies.add(ScenePlugin);
		
		this._rotation = 0;

		this.cvs = document.createElement('canvas');
		this.ctx = this.cvs.getContext('2d');

		this.loader	= new TextureLoader();

		this.src = null;
	}

	attach(){
		this.manager.get(ScenePlugin).on('scene-changed', this.onSceneChanged)
	}

	detach(){
		this.manager.get(ScenePlugin).off('scene-changed', this.onSceneChanged)
	}

	async load(){
		await this.loader.load();
		this.updateTexture();
	}

	get src(){ return this._src; }
	set src(src){
		if(this._src != src){
			this._src = src;
			if(src){
				this.loader.add(src);
				this.load();
			}
		}
	}

	get rotation(){ return this._rotation; }
	set rotation(rotation){
		if(this._rotation != rotation && rotation >= 0 && rotation <= PI2){
			this._rotation = rotation;

			this.updateTexture();
		}
	}

	updateTexture = () => {
		const globalsPlugin = this.manager.get(GlobalsPlugin);
		if(!this.src){
			globalsPlugin.background = null;
			return;
		}
		const texture = this.loader.get(this.src);

		if(texture && texture.image){
			const img = texture.image;

			const  w = img.naturalWidth,
				   h = img.naturalHeight;

			this.cvs.width  = w;
			this.cvs.height = h;

			this.cvs.style.width  = w + 'px';
			this.cvs.style.height = h + 'px';

			const offset = Math.round(this.rotation / PI2 * w);

			this.ctx.drawImage(img, offset, 0, w - offset, h, 0, 0, w-offset, h)
			this.ctx.drawImage(img, 0, 0, offset, h, w-offset, 0, offset, h);

			const cvsTexture = new CanvasTexture(this.cvs, texture.mapping, texture.wrapS, texture.wrapT, texture.magFilter, texture.minFilter, texture.format, texture.type, texture.anisotropy);
			cvsTexture.encoding = sRGBEncoding;
			globalsPlugin.background = cvsTexture;
		}
	}

	onSceneChanged = (scene) => {
		if(scene){
			if(scene.data.envmap){
				this.src = `${APP_URL}/storage/images/${scene.data.envmap.filename}`;
			}
			this.rotation = scene.data.envmap_rotation;
			return;
		}

		this.src = null;
		this.rotation = 0;
	}
}